import ProductInfoTagList from '@/data/productInfoTag/view/list.vue'

const list = {
  path: '/productInfoTag',
  name: 'productInfoTag-list',
  component: ProductInfoTagList
}

export default [list]
